import { format, isValid, parse } from "date-fns";
import { Button } from "../../DanitComponents/Buttons/Button";
import { ListWithInlineDescriptionRed } from "../../DanitComponents/Toggles/ListWithInlineDescription";

const AvailabilityScreenTeacherPortal = ({
  wantsMoreStudents,
  sendWantsMoreStudentsSwitch,
  teacherNotes,
  openUpAvailPopup,
  teacherAvail,
  setNotesPopup,
}) => {
  const allDays = [
    { day: "Monday", abbr: "Mon" },
    { day: "Tuesday", abbr: "Tue" },
    { day: "Wednesday", abbr: "Wed" },
    { day: "Thursday", abbr: "Thu" },
    { day: "Friday", abbr: "Fri" },
    { day: "Saturday", abbr: "Sat" },
    { day: "Sunday", abbr: "Sun" },
  ];

  return (
    <div className="new-teacher-portal__availability">
      <div className="new-teacher-portal__page-label">Availability</div>
      <div
        className="new-teacher-portal__all-buttons-wrapper"
        {...(!wantsMoreStudents && { style: { opacity: "0.2" } })}
      >
        {allDays.map((day, index) => (
          <div
            key={index}
            className="new-teacher-portal__day-button"
            {...(!wantsMoreStudents && { style: { cursor: "default" } })}
            onClick={() => openUpAvailPopup(day.day)}
          >
            <div
              className="new-teacher-portal__day-button__decoration-strip"
              style={
                teacherAvail[day.day].length === 0
                  ? { backgroundColor: "#E89191" }
                  : { backgroundColor: "rgb(154, 207, 157)" }
              }
            ></div>
            <div className="new-teacher-portal__day-square">
              {day.abbr.toUpperCase()}
            </div>
            <div className="new-teacher-portal__label-area">
              {teacherAvail[day.day].map((timeInterval, i) => {
                const startTime = parse(timeInterval.start, "H:mm", new Date());
                const endTime = parse(timeInterval.end, "H:mm", new Date());

                if (!isValid(startTime) || !isValid(endTime)) {
                  return null; // Skip invalid time intervals
                }

                const formattedStartTime = format(startTime, "h:mm a");
                const formattedEndTime = format(endTime, "h:mm a");

                return (
                  <div
                    key={i}
                    className="new-teacher-portal__day-button__availability"
                  >
                    {formattedStartTime} - {formattedEndTime}
                  </div>
                );
              })}
              {teacherAvail[day.day].length === 0 && (
                <div className="new-teacher-portal__day-button__availability not__available">
                  Not Available
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="new-teacher-portal__teacher-notes__wrapper">
        <div className="new-teacher-portal__new-teacher-notes">
          <div style={{ fontSize: "12px" }}>Notes:</div>
          {teacherNotes}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <ListWithInlineDescriptionRed
            label={"Full Studio"}
            value={!wantsMoreStudents}
            action={() => sendWantsMoreStudentsSwitch(!wantsMoreStudents)}
          />
          <Button
            size="md"
            action={() => setNotesPopup(true)}
            text={"Edit Note"}
            color={{
              background: "bg-yellow-500",
              text: "text-white",
              backgroundHover: "bg-blue-400",
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default AvailabilityScreenTeacherPortal;
